var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClineaseLogoLandscape200(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200.00007,
    height: 79.13169,
    viewBox: "0 0 200.00007 79.13169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3809,43.39279c0-11.63708,7.34705-21.15391,18.58946-21.15391,4.14194,0,8.87563,1.82446,12.13002,7.2979l-6.26221,4.73371c-1.52858-2.76136-3.64891-4.4872-6.31155-4.4872-6.06504,0-9.81251,6.75547-9.81251,13.31364,0,4.78305,2.46546,7.44579,6.50878,7.44579,2.61336,0,5.32539-1.33137,7.19909-3.5503l5.52262,5.12824c-3.25439,3.79682-7.93875,6.0158-13.26413,6.0158-8.13598,0-14.29957-4.98029-14.29957-14.74369Z",
    fill: "#cd2026",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.62469,21.4006l-4.48712,36.29206h-7.39639l4.43784-36.29206h7.44566Z",
    fill: "#cd2026",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.26121,33.58017l-2.95854,24.1125h-7.39633l2.95854-24.1125h7.39633ZM67.01278,26.23299c0-2.51478,1.87377-4.33924,4.58574-4.33924,2.66269,0,4.43784,1.77512,4.43784,4.19135,0,2.51478-1.87377,4.38852-4.58574,4.38852-2.61336,0-4.43784-1.82446-4.43784-4.24063Z",
    fill: "#cd2026",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.27842,33.58017l-.39446,3.35306.09862.04928c2.16961-2.51478,4.83231-3.84615,7.98808-3.84615,4.58574,0,6.45944,3.05721,5.5719,9.81268l-1.92304,14.74363h-7.34705l1.72581-13.06713c.4438-3.35306.14795-4.88167-1.42996-4.88167-2.21889,0-5.37467,3.00793-6.1636,9.02374l-1.08484,8.92506h-7.39633l3.00782-24.1125h7.34705Z",
    fill: "#cd2026",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.58568,22.68269l-.8876,7.05132h-13.06684l-.8876,7.14988h10.30559l-.78893,6.80481h-10.30559l-.88755,6.95264h14.00373l-.88755,7.05132h-21.69596l4.28989-35.00997h20.80842Z",
    fill: "#e0ac26",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.72039,48.27452c0-8.57993,5.07882-15.13816,11.39037-15.13816,2.51474,0,4.38851.78894,5.67052,2.12031h.14795l.19723-1.6765h7.44566l-2.95854,24.1125h-7.44566l.4438-3.5503-.14795-.04934c-1.77509,2.56412-4.19127,4.04345-6.90325,4.04345-5.17743,0-7.84013-4.28996-7.84013-9.86196ZM147.28819,42.1601l.09862-.69038c-1.08478-1.13413-2.46546-1.72584-3.99404-1.72584-3.25439,0-5.22671,4.38858-5.22671,7.98822,0,2.31755,1.08478,3.84615,2.76131,3.84615,2.56402,0,5.52256-3.35306,6.36083-9.41815Z",
    fill: "#e0ac26",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.50889,53.99441l4.142-4.28996c1.42996,1.7259,3.59952,2.85998,5.47328,2.85998,1.28201,0,2.21889-.49309,2.21889-1.33137,0-.88756-.98616-1.28203-3.74747-2.71202-3.64886-1.82446-5.86775-3.79687-5.86775-7.34717,0-4.83233,3.9447-8.0375,8.92491-8.0375,3.25439,0,6.50878,1.23275,8.6784,3.84615l-4.48712,4.24068c-1.33135-1.82446-3.00788-2.41623-4.14194-2.4655-.98622,0-1.9231.54243-1.9231,1.47927,0,.789,1.18345,1.57794,3.40234,2.66274,3.74747,1.8738,6.31155,3.59964,6.31155,7.39651,0,4.73371-3.69819,7.84026-9.56594,7.84026-3.45162,0-7.29771-1.47933-9.41805-4.14207Z",
    fill: "#e0ac26",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.74937,48.96484c.44374,2.16959,2.02166,3.05721,3.45162,3.05721,1.6272,0,3.05716-.64105,4.38851-2.41623l5.52256,3.25445c-2.56402,3.50102-5.76913,5.2762-10.50276,5.2762-6.06504,0-10.10836-3.84621-10.05908-10.10853,0-8.18546,5.07888-14.89159,13.21486-14.89159,3.89537,0,8.28387,2.12031,8.23459,6.65685-.09862,6.11442-7.14982,8.43197-14.2503,9.17163ZM191.12403,39.30012c-2.12028,0-4.28989,1.87374-5.12816,5.2268,3.59958-.39447,6.85397-1.33137,6.90325-3.6982.04934-.98624-.64098-1.52861-1.77509-1.52861Z",
    fill: "#e0ac26",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.01204,26.2346c0-2.51468,1.87372-4.3389,4.58549-4.3389,2.66274,0,4.43738,1.77519,4.43738,4.19131,0,2.51468-1.8732,4.38792-4.58497,4.38792-2.6132,0-4.4379-1.82421-4.4379-4.24033Z",
    fill: "#e0ac26",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.97428,
    y: 2.72981,
    width: 1.8195,
    height: 13.28167,
    transform: "translate(-1.00346 13.21587) rotate(-20.58634)",
    fill: "#58899d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.57931,
    cy: 3.1842,
    r: 3.00222,
    fill: "#057187",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.26876,
    y: 8.40027,
    width: 14.02631,
    height: 1.81945,
    transform: "translate(15.19609 42.63269) rotate(-64.65415)",
    fill: "#58899d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.24939,
    cy: 15.61774,
    r: 3.00222,
    fill: "#8aa7b7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.25378,
    cy: 3.00225,
    r: 3.00222,
    fill: "#057187",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.35737,
    y: 11.67263,
    width: 13.28169,
    height: 1.8195,
    transform: "translate(28.42256 59.4079) rotate(-79.38685)",
    fill: "#95b699",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.59543,
    cy: 5.49028,
    r: 3.00222,
    fill: "#75a580",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.63369,
    y: 14.41707,
    width: 14.02619,
    height: 1.81947,
    transform: "translate(.60427 32.66428) rotate(-33.45409)",
    fill: "#95b699",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.78535,
    cy: 19.15127,
    r: 3.00222,
    fill: "#b6cbb6",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.91049,
    cy: 11.89547,
    r: 3.00222,
    fill: "#75a580",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.24724,
    y: 8.45698,
    width: 1.81952,
    height: 13.28155,
    transform: "translate(-3.67386 22.77819) rotate(-52.69925)",
    fill: "#e38456",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.82605,
    cy: 12.11409,
    r: 3.00222,
    fill: "#dc602c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.78704,
    y: 5.16369,
    width: 1.81945,
    height: 14.02635,
    transform: "translate(-1.25592 3.11306) rotate(-6.7677)",
    fill: "#e38456",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.48131,
    cy: 19.13162,
    r: 3.00222,
    fill: "#eca984",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.04281,
    cy: 6.40672,
    r: 3.00222,
    fill: "#dc602c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.36255,
    y: 21.57223,
    width: 1.81953,
    height: 13.28147,
    transform: "translate(-19.00126 34.88751) rotate(-82.83769)",
    fill: "#e7be5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.93856,
    cy: 27.98914,
    r: 3.00222,
    fill: "#e0ac25",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.67058 28.4692 16.22795 29.56823 8.00464 18.45712 9.44727 17.35808 17.67058 28.4692",
    fill: "#e7be5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.90219,
    cy: 29.02821,
    r: 3.00222,
    fill: "#eed190",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.17902,
    cy: 20.20139,
    r: 3.00222,
    fill: "#e0ac25",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.32225,
    y: 42.85378,
    width: 13.28149,
    height: 1.81953,
    transform: "translate(-14.48709 4.98694) rotate(-19.90982)",
    fill: "#d76048",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.0022,
    cy: 45.53659,
    r: 3.00222,
    fill: "#ce2026",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.05641,
    y: 31.35215,
    width: 1.81947,
    height: 14.02616,
    transform: "translate(-30.56595 27.79358) rotate(-63.97776)",
    fill: "#d76048",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.23751,
    cy: 41.47214,
    r: 3.00222,
    fill: "#e28f77",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.23388,
    cy: 36.67221,
    r: 3.00222,
    fill: "#ce2026",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.27926,
    y: 57.15114,
    width: 13.28159,
    height: 1.81951,
    transform: "translate(-38.95827 26.39912) rotate(-46.94171)",
    fill: "#e7be5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.34865,
    cy: 62.28951,
    r: 3.00222,
    fill: "#e0ac25",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.4564,
    y: 52.34115,
    width: 14.02612,
    height: 1.81948,
    transform: "translate(-.93647 .15741) rotate(-1.00907)",
    fill: "#e7be5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.46771,
    cy: 53.1681,
    r: 3.00222,
    fill: "#eed190",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.82963,
    cy: 53.4391,
    r: 3.00222,
    fill: "#e0ac25",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.57767,
    y: 67.67889,
    width: 13.28168,
    height: 1.8195,
    transform: "translate(-49.87021 69.72018) rotate(-72.95013)",
    fill: "#e38456",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.55443,
    cy: 74.10922,
    r: 3.00222,
    fill: "#dc602c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.89382,
    y: 64.43064,
    width: 14.02617,
    height: 1.81947,
    transform: "translate(-27.72731 15.26503) rotate(-27.01732)",
    fill: "#e38456",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.16013,
    cy: 62.19713,
    r: 3.00222,
    fill: "#eca984",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.99205,
    cy: 68.31499,
    r: 3.00222,
    fill: "#dc602c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.06018,
    y: 63.86382,
    width: 1.8195,
    height: 13.28166,
    transform: "translate(-25.37068 20.99375) rotate(-23.87261)",
    fill: "#58899d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.26159,
    cy: 74.91121,
    r: 3.00222,
    fill: "#057187",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.57124,
    y: 69.96491,
    width: 14.02632,
    height: 1.81945,
    transform: "translate(-45.96394 73.52855) rotate(-67.9405)",
    fill: "#58899d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.25035,
    cy: 64.40342,
    r: 3.00222,
    fill: "#8aa7b7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.34291,
    cy: 76.12935,
    r: 3.00222,
    fill: "#057187",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.49248,
    y: 57.02288,
    width: 1.81952,
    height: 13.28151,
    transform: "translate(-28.57672 80.94409) rotate(-63.27452)",
    fill: "#95b699",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.04315,
    cy: 65.5287,
    r: 3.00222,
    fill: "#75a580",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44.56995 60.89592 46.22355 60.36999 50.10974 73.05016 48.45614 73.57609 44.56995 60.89592",
    fill: "#95b699",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.42806,
    cy: 60.67545,
    r: 3.00222,
    fill: "#b6cbb6",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.58358,
    cy: 70.83002,
    r: 3.00222,
    fill: "#75a580",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClineaseLogoLandscape200);
export default __webpack_public_path__ + "static/media/clinease-logo-landscape-200.501171fb62443ff25c72de7f9b193bfb.svg";
export { ForwardRef as ReactComponent };